import Markdown from "markdown-to-jsx";
import pgm from "../../img/officers/provincial-grand-master.jpg";
import dpgm from "../../img/officers/deputy-provincial-grand-master.jpg";
import secretary from "../../img/officers/provincial-grand-secretary.jpg";
import provincialTeamContents from "../../markdown/about/team.md";
import {useEffect, useState} from "react";
import GrandOfficers from "./grandOfficers";

export function ProvincialTeam() {
    const [team, setTeam] = useState('')

    useEffect(() => {
        fetch(provincialTeamContents)
            .then((res) => res.text())
            .then(value => setTeam(value))
            .catch(reason => console.log(reason))
    })

    return (
        <>
            <div className="section has-text-centered">
                <h1 className="title">Provincial Team</h1>
                <div className="section has-text-centered">
                    <Markdown>{team}</Markdown>
                </div>

                <div className="columns is-centered">
                    <div className="column is-12-mobile is-4-tablet is-4-desktop" style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="has-text-centered" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                            <p>Provincial Grand Master</p>
                            <div style={{flexGrow: 1, display: 'flex', alignItems: 'flex-end'}}>
                                <img alt="" src={pgm} style={{maxWidth: '100%', height: 'auto'}}/>
                            </div>
                        </div>
                        <div style={{marginTop: '20px'}}>
                            <p>Right Worshipful Brother Andrew Stuart Lee, P.G.S.D.</p>
                            <p>Installed May 2025</p>
                        </div>
                    </div>
                    <div className="column is-12-mobile is-4-tablet is-4-desktop" style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="has-text-centered" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                            <p>Deputy Provincial Grand Master</p>
                            <div style={{flexGrow: 1, display: 'flex', alignItems: 'flex-end'}}>
                                <img alt="" src={dpgm} style={{maxWidth: '100%', height: 'auto'}}/>
                            </div>
                        </div>
                        <div style={{marginTop: '20px'}}>
                            <p>Worshipful Brother Iain Barclay Walker, P.A.G.D.C.</p>
                            <p>Appointed May 2025</p>
                        </div>
                    </div>
                    <div className="column is-12-mobile is-4-tablet is-4-desktop" style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="has-text-centered" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                            <p>Provincial Grand Secretary</p>
                            <div style={{flexGrow: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}>
                                <img alt="" src={secretary} style={{maxWidth: '100%', height: 'auto', transform: 'scale(1.2)', marginBottom: '51px'}}/>
                            </div>
                        </div>
                        <div style={{marginTop: '20px'}}>
                            <p>Worshipful Brother Roger A.E. Whale</p>
                            <p>Appointed and Invested May 2023</p>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section" id="grandofficers">
                {<GrandOfficers/>}
            </section>
        </>)
}

export default ProvincialTeam